export default {
  pushToken(state, payload) {
    state.cancelTokenArr.push(payload.cancelToken);
  },
  clearToken(state) {
    state.cancelTokenArr.forEach(item => {
      if (item != null)
        item('路由跳转取消请求');
    });
    state.cancelTokenArr = [];
  },
  setLoadingOptionArr(state, val) {
    state.loading_option = val
  },
  setWorkOrderActId(state, val) {
    state.WorkOrderActId = val
  },
  setChannelActId(state, val) {
    state.ChannelActId = val
  },
  setMoneyConfigActId(state, val) {
    state.MoneyConfigActId = val
  },
  setUserCommonData(state, val) {
    state.user_common_data = val
  },
  setChannelAccountWechatArr(state, val) {
    state.channel_account_wechat = val
  },
  setMerchantAccountWechatArr(state, val) {
    state.merchant_account_wechat = val
  },
  setWechatArr(state, val) {
    state.wechat_arr = val
  },
  setOrderArr(state, val) {
    state.order_arr = val
  },
  setProjectArr(state, val) {
    state.project_arr = val
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js